import { ChangeEvent, MouseEvent, KeyboardEvent } from 'react';
import { IInputWithButtonProps } from './IInputWithButtonProps';
import { EButtonStyle } from './InputWithButton';
import './InputWithButton.css';

interface ITextAreaWithButtonProps extends IInputWithButtonProps {
    inputRef?: React.RefObject<HTMLTextAreaElement>;
    onClick: (e: MouseEvent | KeyboardEvent<HTMLTextAreaElement>) => void;
    onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

export const TextAreaWithButton = (props: ITextAreaWithButtonProps) => {
    const wrapperClass = `${props.wrapperClassName} ${
        props.withBackground ? 'input-with-button-wrapper' : ''
    }`;
    const buttonStyle = props.buttonStyle || EButtonStyle.PRIMARY;

    const onKeyDownHandler = (event: KeyboardEvent<HTMLTextAreaElement>) => {
        if (event.key === 'Enter') {
            props.onClick(event);
        }
    };

    return (
        <div className={wrapperClass}>
            <div className={'input-with-button-inner-wrapper'}>
                {props.prefixIcon && <div>{props.prefixIcon}</div>}

                <textarea
                    data-testid={'input-with-button-input'}
                    value={props.inputValue}
                    placeholder={props.placeholder}
                    onChange={props.onChange}
                    onKeyDown={onKeyDownHandler}
                    className={'input-with-button-input'}
                    disabled={props.inputDisabled}
                    name={props.inputName}
                    rows={3}
                    ref={props.inputRef}
                />

                {props.suffixIcon && (
                    <div className='mr-3 ml-auto'>{props.suffixIcon}</div>
                )}

                <button
                    type='button'
                    data-testid={'input-with-button-button'}
                    className={`susy-button susy-button-${buttonStyle} susy-button-sm mr-1 input-with-button-button`}
                    onClick={props.onClick}
                    disabled={props.buttonDisabled}
                >
                    {props.buttonText}
                </button>
            </div>
        </div>
    );
};
